import MaterialRequestHeaderFilter from './MaterialRequestHeaderFilter';
import MaterialRequestTable from './MaterialRequestTable';

const MaterialRequestPage = () => {
  return (
    <>
      <div className={'page-wrapper'}>
        <MaterialRequestHeaderFilter />
        <MaterialRequestTable />
      </div>
    </>
  );
};

export default MaterialRequestPage;
